<template>
  <div>
    <h5>
      {{ $t('hanwha_camera.change_password') }} - {{ itemDataPassword.user }}
    </h5>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-row class="mx-0 mt-1 justify-content-center">
        <b-col cols="7">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.current_password')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.current_password')"
              label-for="current_password"
            >
              <b-form-input
                id="current_password"
                v-model="itemDataPassword.current_password"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="7">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.new_password')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.new_password')"
              label-for="current_password"
            >
              <b-form-input
                id="new_password"
                v-model="itemDataPassword.new_password"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="7">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.confirm_new_password')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.confirm_new_password')"
              label-for="confirm_new_password"
            >
              <b-form-input
                id="confirm_new_password"
                v-model="itemDataPassword.confirm_new_password"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import axios from "@axios";
import { onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    flatPickr,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    hanwhaDvr: {
      type: Object
    },
    itemDataPassword: {
      type: Object
    }
  },
  setup (props) {
    //HOOKS
    onMounted(async () => await getRsaKey());
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    const { t,tc } = useI18nUtils();


    //METHODS
    const getRsaKey = async() => {
      const params = {
        action: 'get-rsa-key',
        id_dvr: props.hanwhaDvr.id,
        params: {}
      }

      await axios.post('/v1/hanwha/dvr/admin/users', params)
        .then(response => {
          const { data } = response;

          props.itemDataPassword.rsa_key = data.data.PublicKey;
        })
        .catch(error => {
          props.itemDataPassword.rsa_key = null;
        });
    }

    const popoverConfig = () => {
      return `
        <div>
          <small>- Debe tener entre 8 y 20 caracteres, contener letras y números.</small>
        </div>
        <div>
          <small>- No debe contener espacios, caracteres especiales ni emojis.</small>
        </div>
        <div>
          <small>- El ID de usuario no podrá utilizarse como contraseña</small>
        </div>
        <div>
          <small>- No utilice más de 4 caracteres consecutivos (ej. 1234, abcd, etc.).</small>
        </div>
        <div>
          <small>No utilice el mismo carácter repetidamente más de 4 veces (ej. !!!!, 1111, aaaa, etc.).</small>
        </div>
      `;
    }

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }

      const validation = await refFormObserver.value.validate();

      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      popoverConfig,
      validateStep,
      withPopper: popperHelper.withPopper
    }
  }
}
</script>
